"use client";

import { forwardRef } from "react";
import {
  Box,
  Slide,
  styled,
} from "@mui/material";
import { Dialog } from "@components/shared/DialogCompat";

const Container = styled(Box)({
  width: "100%",
  minHeight: "90vh",
  display: "flex",
  flexDirection: "column",
  padding: "0 62px 38px",
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function Terms({ open, onClose, url }) {
  return (
    <Dialog
      maxWidth="md"
      fullWidth
      onClose={onClose}
      open={open}
      keepMounted
      disableAutoFocus={true}
      disableEnforceFocus={true}
      TransitionComponent={Transition}
    >
      <Container>
        <iframe
          src={url}
          title="Terms and Policies"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </Container>
    </Dialog>
  );
}
